const getTemporaryContainerInfo = state => state.cart.temporaryContainerInfo;
const getCartItems = state => state.cart.cartItems;
const getQuantity = state => state.cart.quantity;

export { getTemporaryContainerInfo, getCartItems, getQuantity };
